import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ThemeProvider } from '@material-ui/styles';
import { StripeProvider } from 'react-stripe-elements';

import theme from './theme';

import { setInitialAuth } from './redux/actions/auth';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Routes from './Routes';

class App extends Component {
  state = {
    stripe: null
  };

  componentDidMount() {
    this.props.setInitialAuth();
  }

  render() {
    const { modalIsOpen, role, loggedIn, location, history } = this.props;

    return (
      <StripeProvider stripe={this.state.stripe}>
        <ThemeProvider theme={theme}>
          <Routes />
          <ToastContainer/>
        </ThemeProvider>
      </StripeProvider>
    );
  }
}

App.propTypes = {
  setInitialAuth: PropTypes.func
};

App.defaultProps = {
//  modalIsOpen: false,
//  role: { admin: false, manager: false },
  setInitialAuth: () => {}
};

const mapStateToProps = state => ({
//  modalIsOpen: state.modal.isOpen,
//  role: state.auth.role,
  loggedIn: state.auth.jwt
});

export default connect(
  mapStateToProps,
  { setInitialAuth }
)(App);
